<template>
  <div class="banners-root" v-if="this.bannerList && this.bannerList.length > 0">
    <el-carousel arrow="always" height="450px" autoplay >
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <img
          :src="item.imgurl"
          style="width: 100%;height: 450px;cursor:pointer;"
          @click="toNext(item)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  name: 'Banners',
  computed: {
    bannerList () {
      return this.$store.getters.maindataImgs
    },
  },
  methods: {
    toNext (item) {
      if (item.linkurl) {
        window.location.href = item.linkurl
      }
    }
  }
}
</script>
<style lang="less" scoped>
.banners-root {
  width: 1190px;
  min-width: 1190px;
  margin: 0 auto;
  position: relative;
}
</style>